import formActions from "../utils/common-form-actions";
import subscriber from "../utils/subscribe-actions";

export default context => {
    const container = $('#AttendeesContainer', context)
    if (container.length) {
        let currentSectionIndex = 0;
        const template = $(container.data('template'), context).html()
        const footer = $(container.data('footer'), context).html()
        const prefix = container.data('prefix')
        const ticketsContainer = $(container.data('tickets-container'))
        const modal = container.closest('.modal')
        const sections = [... new Set($('.form-group[data-section]')
            .map((i, em) => $(em).data('section')).get()
            // .sort((a, b) => a - b)
        )]

        modal.find('.modal-footer').html(footer);

        const updateFooter = function ()
        {
            if (currentSectionIndex >= sections.length - 1) {
                modal.find('.modal-footer .buttons-continue').hide()
                modal.find('.modal-footer .buttons-submit').show()
            } else {
                modal.find('.modal-footer .buttons-continue').show()
                modal.find('.modal-footer .buttons-submit').hide()
            }
        }

        const validatePage = async () => {
            let form = modal.find('form');
            formActions.cleanForm(form);
            let formData = new FormData(form[0]);
            formData.append('validateOnly', 1)
            // remove invisible attributes
            // it allows to avoid manipulations with 'disabled'.
            modal.find('.form-group:not(:visible)').find('input,select,textarea').each(function() {
                formData.delete($(this).attr('name'))
            })
            spinner.show();
            try {
                const data = await $.ajax({
                    url: '/site/groups/users-subscribe',
                    data: formData,
                    processData: false,
                    contentType: false,
                    type: 'post',
                    dataType: 'json'
                })
                spinner.remove();
                if (data.success) {
                    return true
                } else {
                    formActions.applyFormErrors(form, data.errors || {}).then(() => {
                        window.openAlert(data.message || '', 'error');
                        form.find('.has-error :visible:focusable:first').focus();
                    });
                    return false
                }
            } catch (e) {
                spinner.remove()
                return false
            }
        }

        modal.find('.btn-nextpage').on('click', async () => {
            if (await validatePage()) {
                showSection(Math.min(currentSectionIndex + 1, sections.length - 1))
            }
        })
        modal.find('.btn-back').on('click', () => {
            showSection(Math.max(currentSectionIndex - 1, 0))
        })

        const showSection = function(newSectionIndex)
        {
            const section = sections[newSectionIndex]
            currentSectionIndex = newSectionIndex
            updateFooter()
            $('.form-group[data-section]').hide()
                .filter(`[data-section=${section}]`).show()
                .trigger('show-section.coing')
        }

        const buildAttendeesForm = () => {
            container.html('')
            let index = 0;
            ticketsContainer.find('input.product-count').each(function () {
                const $this = $(this)
                for (let i = 0; i < $this.val(); i++) {
                    const str = template
                        .replaceAll('{ticket_name}', $this.closest('.subscription-product-row').find('.ticket-name').html())
                        .replaceAll('{i}', index)
                        .replaceAll('{key}', prefix + `[${index++}]`)
                    $(str).appendTo(container)
                }
            })
            if (container.find('.attendee-container').length === 0) {
                modal.find('.btn-continue').trigger('click')
                return
            }
            const first = container.find('.attendee-container:first')
            const userAutoFill = container.closest('.modal').find('#user_auto_fill').data();
            first.find('input[id$=first_name]').val(userAutoFill.first_name)
            first.find('input[id$=last_name]').val(userAutoFill.last_name)
            first.find('input[id$=email]').val(userAutoFill.email)
            first.find('input[id$=phone]').val(userAutoFill.phone ? '+' + userAutoFill.phone : '')
            first.find('input[id$=citizen_id]').val(userAutoFill.identification)

        }
        $('.field-editsubscriber-attendees').on('show-section.coing', buildAttendeesForm)

        showSection(0)
    }
}
